export default __webpack_public_path__ + "static/media/img-30.e009c1f2.jpg";